import { downloadUrl, version } from 'virtual:santa-market-extension';
import { Hint } from '@src/components/Hint/Hint';

export function MarketExtensionGuide({ ru }: { ru: boolean }) {
  const words = (en: string, russian: string) => (ru ? russian : en);
  return (
    <Hint tone="info">
      <details>
        <summary>
          {words(
            'How to add goods from Yandex Market faster',
            'Как быстрее добавлять товары с Яндекс Маркета',
          )}
        </summary>
        <a href={downloadUrl} download>
          {words('Download Santa extension', 'Скачать расширение Santa')} · ZIP · v{version}
        </a>
        <ol>
          <li>
            {words(
              'Download the ZIP and extract it into a permanent folder on your computer. Keep this folder after installation.',
              'Скачайте ZIP и распакуйте его в постоянную папку на компьютере. Не удаляйте эту папку после установки.',
            )}
          </li>
          <li>
            {words('In desktop Chrome, enter', 'В Chrome на компьютере введите')}{' '}
            <code>chrome://extensions</code>{' '}
            {words('in the address bar. In Edge, use', 'в адресной строке. В Edge используйте')}{' '}
            <code>edge://extensions</code>.
          </li>
          <li>
            {words(
              'Enable Developer mode. Click “Load unpacked” and select the extracted santa-market-extension folder containing manifest.json, not the ZIP file.',
              'Включите «Режим разработчика». Нажмите «Загрузить распакованное расширение» и выберите распакованную папку santa-market-extension с файлом manifest.json, а не ZIP.',
            )}
          </li>
          <li>
            {words(
              'Pin “Santa — Yandex Market importer” using the browser’s extensions menu (puzzle icon).',
              'Закрепите «Santa — Yandex Market importer» в меню расширений браузера (значок пазла).',
            )}
          </li>
          <li>
            {words(
              'Open a product on Yandex Market, choose the desired variant, open Santa’s extension and click “Скопировать товар”.',
              'Откройте товар на Яндекс Маркете, выберите нужный вариант, откройте расширение Santa и нажмите «Скопировать товар».',
            )}
          </li>
          <li>
            {words(
              'Return here and click “Paste product”. Review the name, photo and price before saving. If clipboard access is unavailable, paste the copied data into the text box.',
              'Вернитесь сюда и нажмите «Вставить товар». Проверьте название, фото и цену перед сохранением. Если доступ к буферу обмена недоступен, вставьте скопированные данные в текстовое поле.',
            )}
          </li>
        </ol>
        <p>
          {words(
            'To update: download the current ZIP, replace the files in the same installation folder, then click Reload on the extension’s card in chrome://extensions (or edge://extensions). Installed copies do not update automatically.',
            'Для обновления скачайте текущий ZIP, замените файлы в той же папке установки и нажмите «Обновить» на карточке расширения в chrome://extensions (или edge://extensions). Установленные копии не обновляются автоматически.',
          )}
        </p>
      </details>
    </Hint>
  );
}
